import React, { useState, useRef } from 'react';

export function useThrottleState<T>({ initialState, limit }: { initialState: T; limit: number }): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [throttledValue, setThrottledValue] = useState(initialState);
    const lastRan = useRef(Date.now());

    const lastArgs = useRef<T | null>(null);
    const leadingRun = useRef(false);
    const timeoutHook = useRef(0);

    const throttle = (value: T) => {
        if (!value) return;
        if (!leadingRun.current) {
            leadingRun.current = true;
            setThrottledValue(value);
        }

        lastArgs.current = value;

        if (timeoutHook.current) return;
        timeoutHook.current = setTimeout(
            () => {
                timeoutHook.current = 0;

                if (!lastArgs.current) return;
                lastRan.current = Date.now();
                leadingRun.current = false;
                setThrottledValue(lastArgs.current);
            },
            limit - (Date.now() - lastRan.current)
        );
    };
    return [throttledValue, throttle];
}
